export default "__VITE_ASSET__DJwfFpB5__"